import { useAppContext } from 'components/Context/AppContext';
import { Button } from 'components/Global';
import { useDispatch, useSelector } from 'react-redux';
import Modals from '../Modals';
import { trackEvent } from 'utils/analytics';
import { ReactComponent as DriverIcon } from 'icons/driving-wheel-icon.svg';
import { useState, useEffect } from 'react';
import TextAreaInput from 'components/Global/TextArea';
import { getAllDrivers } from 'features/drivers/actions';
import { setPage } from 'features/drivers/slice';
import { getApprovalSettings, updateApprovalOrder } from 'features/approvals/actions';
import { isEmpty } from 'utils/helpers';

const CANCEL_REASON_CHOICE = [
  {
    id: 1,
    label: 'Driver memutuskan untuk mengakhiri kerjasama',
  },
  {
    id: 2,
    label: 'Driver terindikasi melanggar perjanjian kerjasama',
  },
  {
    id: 3,
    label: 'Driver terdeteksi memiliki dua akun',
  },
  {
    id: 4,
    label: 'Lainnya',
  },
];

const DeleteDriverReasonModal = () => {
  const driverData = useSelector((state) => state.drivers.selected);
  const approvalData = useSelector((state) => state.approvals.approvalSetting);

  const { setShowDeleteDriverReasonModal, showToast, setShowConfirmation } = useAppContext();

  const [selectedReason, setSelectedReason] = useState({
    id: 0,
    label: '',
  });
  const [cancelReason, setCancelReason] = useState('');

  const dispatch = useDispatch();

  const onConfirm = async () => {
    if (!selectedReason.id) return showToast({ message: 'Harap memilih alasan menghapus driver!', type: 'info' });
    else if (selectedReason.id === 4 && isEmpty(cancelReason))
      return showToast({ message: 'Harap mengisi alasan menghapus driver!', type: 'info' });

    const getDeletedReason = selectedReason.id === 4 ? cancelReason : selectedReason.label;

    const payload = {
      reference_id: driverData?.id,
      reference_type: 'user',
      approval_setting_id: approvalData?.data[0]?.id,
      data: {
        ...driverData,
        deleted_reason: getDeletedReason,
      },
    };

    setShowConfirmation({
      message: 'Apakah anda ingin menghapus Driver ini?',
      show: true,
      onClick: async () => {
        try {
          trackEvent('approval_decided', {
            order_id: driverData?.id,
            decision: 'delete',
            source: 'delete_driver_reason_modal',
          });
          await dispatch(updateApprovalOrder(payload)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Hapus Driver!' });
          dispatch(getAllDrivers(1));
          dispatch(setPage(1));
        } catch (err) {
          showToast({ type: 'error', message: 'Gagal Hapus Driver!' + `[${err?.message}]` });
        } finally {
          setShowDeleteDriverReasonModal(false);
        }
      },
    });
  };

  useEffect(() => {
    dispatch(getApprovalSettings({ key: 'delete-driver', limit: 5 }));
  }, []);

  return (
    <Modals
      setState={setShowDeleteDriverReasonModal}
      icon={<DriverIcon fill="#009EF7" width="25px" height="25px" />}
      title="Alasan Hapus Driver"
    >
      <div className="delete-driver">
        <h5 className="delete-driver__title">Pilih Alasan Pembatalan</h5>
        <ul className="delete-driver__options">
          {CANCEL_REASON_CHOICE.map((item) => (
            <div key={item.id} className="delete-driver__options-item">
              <input
                type="radio"
                name="reason"
                value={item.label}
                id={item.id + ''}
                onChange={() => setSelectedReason(item)}
                checked={item.id === selectedReason?.id}
              />
              <label htmlFor={item.id + ''}>{item.label}</label>
            </div>
          ))}
          {selectedReason.id === 4 && (
            <section className="mb-5">
              <TextAreaInput
                value={cancelReason}
                placeholder="Tulis Alasan.."
                onChange={(e) => setCancelReason(e.target.value)}
                name="other-reason"
                id="other-reason"
                rows={6}
                className="py-2.5 text-xs"
              />
            </section>
          )}
        </ul>
        <div className="delete-driver__btn-group">
          <Button variant="outline" onClick={() => setShowDeleteDriverReasonModal(false)}>
            Kembali
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Submit
          </Button>
        </div>
      </div>
    </Modals>
  );
};

export default DeleteDriverReasonModal;
